import { isArray } from 'lodash';
import React, { useMemo, useState, useEffect } from 'react';
import { Select, MultiSelect } from '@grafana/ui';

function VariableValueSelect({ model }) {
  const { value, key } = model.useState();
  const onInputChange = model.onSearchChange ? (value2, meta) => {
    if (meta.action === "input-change") {
      model.onSearchChange(value2);
    }
  } : void 0;
  return /* @__PURE__ */ React.createElement(Select, {
    id: key,
    placeholder: "Select value",
    width: "auto",
    value,
    allowCustomValue: true,
    tabSelectsValue: false,
    onInputChange,
    options: model.getOptionsForSelect(),
    onChange: (newValue) => {
      model.changeValueTo(newValue.value, newValue.label);
    }
  });
}
function VariableValueSelectMulti({ model }) {
  const { value, key, maxVisibleValues } = model.useState();
  const arrayValue = useMemo(() => isArray(value) ? value : [value], [value]);
  const [uncommittedValue, setUncommittedValue] = useState(arrayValue);
  useEffect(() => {
    setUncommittedValue(arrayValue);
  }, [arrayValue]);
  const onInputChange = model.onSearchChange ? (value2, meta) => {
    if (meta.action === "input-change") {
      model.onSearchChange(value2);
    }
  } : void 0;
  return /* @__PURE__ */ React.createElement(MultiSelect, {
    id: key,
    placeholder: "Select value",
    width: "auto",
    value: uncommittedValue,
    noMultiValueWrap: true,
    maxVisibleValues: maxVisibleValues != null ? maxVisibleValues : 5,
    tabSelectsValue: false,
    allowCustomValue: true,
    options: model.getOptionsForSelect(),
    closeMenuOnSelect: false,
    isClearable: true,
    onInputChange,
    onBlur: () => {
      model.changeValueTo(uncommittedValue);
    },
    onChange: (newValue) => {
      setUncommittedValue(newValue.map((x) => x.value));
    }
  });
}
function renderSelectForVariable(model) {
  if (model.state.isMulti) {
    return /* @__PURE__ */ React.createElement(VariableValueSelectMulti, {
      model
    });
  } else {
    return /* @__PURE__ */ React.createElement(VariableValueSelect, {
      model
    });
  }
}

export { VariableValueSelect, VariableValueSelectMulti, renderSelectForVariable };
//# sourceMappingURL=VariableValueSelect.js.map
